<template>
<div style="font-family: -apple-system-font ,Helvetica Neue,Helvetica,STHeiTi,sans-serif;">
  <div class="carousel">
    <img src="../../assets/images/developerCommunity/dev_banner.jpg" alt="">
  </div>
  <div class="case_main">
    <div class="case_top">
      <div class="case_title">区块链开源技术有哪些？</div>
      <div class="case_time">
        <span><img src="../../assets/images/developerCommunity/dev_time.png" alt="">2020/06/12</span>
        <span><img src="../../assets/images/developerCommunity/dev_people.png" alt="">Eiiplat 平台</span>
      </div>
      <hr>
    </div>
    <div class="case_detail">
      <div class="model">
        <div class="section">
          目前区块链的相关开源技术主要有四大类： </div>

      </div>
      <div class="model">

        <div class="model_title">第一类：Bletchley —— 微软开源区块链平台项目</div>
        <div class="section">
          微软称已经了解区块链的基本原理，以及其特点，将把区块链整合到企业级项目中。为此，微软开启了Bletchley项目，Bletchley充分展现了微软开放性视野，Bletchley模块化区块链将给Azure注入新的动力。
        </div>
      </div>
      <div class="model">
        <div class="model_title">第二类：Hyperledger Fabric</div>
        <div class="section">
          Hyperledger Fabric 是一个开源区块链实现，开发环境建立在VirtualBox虚拟机上，部署环境可以自建网络，也可以直接部署在BlueMix上，部署方式可 传统可docker化，共识达成算法插件化，支持用Go和Java开发智能合约，尤以企业级的安全机制和membership机制为特色。你 要是不知道这些术语什么意思，就记住一点，Fabric之于区块链，很可能正如Hadoop之于大数据。
        </div>
      </div>
      <div class="model">
        <div class="model_title">第三类：Openchain —— 分布式总账区块链工具</div>
        <div class="section">
          Openchain 是由区块链技术公司Coinprism开源分布式总账区块链工具，主要提供给大型企业和金融机构，Openchain 在处理大型企业和金融机构的数据的时候，相较于传统的区块链工具，能大大的降低计算速度，并能降低成本和交易方风险
        </div>
      </div>
      <div class="model">
        <div class="model_title">第四类：BitShares —— 点对点的多态数字资产交易系统</div>
        <div class="section">
          BitShares 旨在建立一套点对点的多态数字资产交易系统，能够跟踪黄金、白银、美元或者其他货币的价值，并且让持有者获得红利的同时避免所有的交易对手风险。 BitShares拓展了比特币的技术，在一个全新的点对点的多功能网络中，提供了很多传统货币功能，以及能够让比特币和其它常见金融资产共同使用的支票 账户、储蓄账户和证券经纪工具。
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'DeveloperDetail',
  data() {
    return {
      detailId: this.$route.params.id,
    }
  },
  mounted() {
    window.scrollTo(0, 0)
    this.init()
  },
  methods: {
    init() {
      console.log(this.detailId)
    }
  }
}
</script>

<style lang="scss">
.carousel {
  img {
    width: 100%;
  }
}

.case_main {
  padding: 0 2.4rem;
  margin-bottom: 0.3rem;

  .case_top {
    margin-top: 0.6rem;

    .case_title {
      font-size: 0.4rem;
    }

    .case_time {
      display: flex;

      span {
        font-size: 0.18rem;
        color: #999;
        margin-right: 0.35rem;
        display: flex;
        align-items: center;
      }

      img {
        width: 0.2rem;
        height: 0.2rem;
        margin-right: 0.1rem;
      }
    }

    hr {
      margin: 0.4rem 0;
      color: #cccccc;
    }
  }

  .case_detail {
    margin: 0 2.2rem;
    margin-bottom: 0.6rem;
    color: #000000;

    img {
      width: 100%;
    }

    .model {
      margin-top: 0.2rem;

      .model_title {
        font-size: 0.22rem;
        font-weight: 600;
      }

      .section {
        padding-left: 0.12rem;
        text-indent: 2em;
        line-height: 0.36rem;
        font-size: 0.18rem;
        margin-top: 0.12rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/detail_page/DeveloperDetail.vue